var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validIcon)?_c('div',{staticClass:"faction-icon",style:(_vm.offsetStyle),attrs:{"title":_vm.icon.name}}):_c('div',{staticClass:"faction-icon"})}
var staticRenderFns = []

export { render, staticRenderFns }